// @ts-nocheck
import { PhoneIncoming, AlertCircle } from 'lucide-react'

/**
 * 着信音有効化を促すモーダル
 * ページロード時に表示され、ユーザーに受付開始を促す
 */
export default function RingAudioPromptModal({ isOpen, onActivate }) {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm">
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl max-w-md w-full mx-4 overflow-hidden animate-in fade-in zoom-in duration-300">
        {/* ヘッダー */}
        <div className="bg-gradient-to-r from-orange-500 to-red-500 p-6 text-white">
          <div className="flex items-center justify-center mb-4">
            <div className="bg-white/20 p-4 rounded-full">
              <PhoneIncoming className="w-12 h-12 animate-bounce" />
            </div>
          </div>
          <h2 className="text-2xl font-bold text-center mb-2">
            着信受付を開始してください
          </h2>
          <p className="text-center text-white/90 text-sm">
            着信音を有効にして通話を受け付けます
          </p>
        </div>

        {/* コンテンツ */}
        <div className="p-6">
          <div className="bg-yellow-50 dark:bg-yellow-900/20 border-2 border-yellow-400 dark:border-yellow-600 rounded-lg p-4 mb-6">
            <div className="flex gap-3">
              <AlertCircle className="w-5 h-5 text-yellow-600 dark:text-yellow-400 flex-shrink-0 mt-0.5" />
              <div className="text-sm text-yellow-800 dark:text-yellow-200">
                <p className="font-semibold mb-1">重要</p>
                <p>
                  このボタンを押さないと着信音が鳴りません。
                  着信に気づけるよう、必ずボタンを押して受付を開始してください。
                </p>
              </div>
            </div>
          </div>

          <button
            onClick={onActivate}
            className="w-full py-4 px-6 bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600 text-white text-lg font-bold rounded-xl shadow-lg hover:shadow-xl transition-all flex items-center justify-center gap-3 animate-pulse"
          >
            <PhoneIncoming className="w-6 h-6" />
            <span>受付を開始する (着信音ON)</span>
          </button>

          <p className="text-xs text-gray-500 dark:text-gray-400 text-center mt-4">
            ※ボタンを押すまで着信があっても音で通知されません
          </p>
        </div>
      </div>
    </div>
  )
}
